<template>
  <v-container class="pa-0">
    <h3 class=" mb-0">Upload a Classroom Observation</h3>
    <hr class="thick" />
    <v-textarea
      outline
      label="Add a comment about your observation"
      v-model="description"
      required
    ></v-textarea>
    <amaze-upload id="classroom-observation"></amaze-upload>
    <v-btn @click="createNewCard()" primary :disabled="submitting"
      >Upload</v-btn
    >
    <a @click="returnToGroup()" flat outline>Cancel and Close</a>
  </v-container>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
.resourceBox {
  background-color: $amaze-yellow-background;
}
::v-deep form {
  .v-input__slot {
    label {
      font-size: 15px;
      line-height: 1.5em;
      font-weight: bolder;
    }
  }
}
</style>

<script>
import { EventBus } from "@/components/Events/event-bus.js";
import cardMixin from "@/mixins/cardMixin.js";
import cardCrudMixin from "@/mixins/cardCrudMixin.js"

export default {
  mixins: [cardMixin, cardCrudMixin],
  data() {
    return {
      description: null,
      userfile_id: null,
      submitting: false
    };
  },
  mounted() {
    const returnRoute = "/group/" + this.$route.params.id;
    this.$emit('setReturnRoute', returnRoute);
  },
  computed: {
    summary: function () {
      return this.createSummary(this.description) || "";
    }
  },
  methods: {
    createNewCard() {
      const groupId = this.$route.params.id;
      const newCard = {
        name: "My Great Card",
        card_type_id: 3,
        user_id: this.$auth.user().id,
        allow_comments: 1,
        allow_likes: 1,
        groups: [groupId],
        summary: this.createSummary(this.description),
        card: {
          question: this.question
        }
      };
      this.submitting = true;
      this.$http
        .post("cards", newCard)
        .then(
          response => {
            EventBus.$emit("refresh-cards", groupId, true);
            this.returnToGroup();
          },
          response => {
            console.log("Error creating card.");
          }
        )
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
